import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListDescriptionDirective } from './list-description.directive';

@NgModule({
  declarations: [ListDescriptionDirective],
  imports: [CommonModule],
  exports: [ListDescriptionDirective],
})
export class ListDescriptionModule {}
